module.exports = __webpack_public_path__ + "img/chip03.5407aad3.png";